export function closeCurrentTag(vue, next, fallback) {
  vue.$store.dispatch('delView', vue.$route).then(({ visitedViews }) => {
    const latestView = visitedViews.slice(-1)[0];
    if (next) {
      vue.$router.push(next);
    } else if (latestView) {
      vue.$router.push(latestView);
    } else if (fallback) {
      vue.$router.push(fallback);
    } else {
      vue.$router.push('/');
    }
  });
}
